import { MuiButton } from '@/components/button/MuiButton';
import { Box, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export function RequireLoginButton({
  text,
  onClick,
}: {
  text: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <MuiButton
        startIcon={
          <LockIcon
            sx={{
              color: '#FFB300',
            }}
          />
        }
        onClick={onClick}
        variant="outlined"
        sx={{
          width: '100%',
          minWidth: 160,
          paddingTop: 1,
          paddingBottom: 1,
          height: 44,
          color: '#7B7B7B',
          borderColor: '#7B7B7B',
          backgroundColor: '#FAFAFA',
          ':hover': {
            borderColor: '#7B7B7B',
            backgroundColor: '#FAFAFA',
          },
        }}
      >
        <Typography
          variant="JP/Body/m/Regular/Tight"
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            textAlign: 'left',
            flex: 1,
          }}
        >
          {text}
        </Typography>
      </MuiButton>
    </Box>
  );
}
